import script from "./AnnouncementsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsPanel.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsPanel.vue?vue&type=style&index=0&id=2e65cab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e65cab0"]])

export default __exports__